import DepartmentTable from "./components/DepartmentTable";

const DepartmentComponent = () =>{

    return(
        <DepartmentTable />
    )
}
export default DepartmentComponent;